import { ENV } from "@/env";
import Axios from "axios";

const createAxios = Axios.create({
  // baseURL: "https://sistemas.tel.inf.br/vega/api/v1",
  baseURL: ENV.BASE_URL,
  // baseURL: "https://localhost:44350/api/v1"
});

createAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("vega@token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

createAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error)
    if (error.response?.status === 401) {
      localStorage.removeItem("vega@token");
      localStorage.clear();

      window.location = "/";
    }
    return Promise.reject(error);
  }
);

export default createAxios;
